import { toast } from 'sonner';

import { Button } from '@/components/ui/Button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/Dialog';
import { useRemoveModel } from '@/hooks/useRemoveModel';
import { FilterModelsDto, Model } from '@/services/ModelsService';

export function RemoveModelDialog({
  open,
  onClose,
  model,
  filter,
}: {
  open: boolean;
  onClose: () => void;
  model: Model;
  filter: FilterModelsDto;
}) {
  const { removeModel, isRemoving } = useRemoveModel(filter);

  const handleDelete = async () => {
    try {
      await removeModel(model.id);
      toast.success('Model removed successfully');
      onClose();
    } catch (error) {
      toast.error('Failed to remove model. Please try again.');
    }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Confirm deletion</DialogTitle>
          <DialogDescription>
            Are you sure you want to delete this model {String(model.id)}?
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={isRemoving}>
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={handleDelete}
            disabled={isRemoving}
          >
            {isRemoving ? 'Removing...' : 'Delete'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
